const youtubeRegExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/

export default {
  methods: {
    getVideoId(url) {
      if (!url) {
        return ''
      }
      const match = url.match(youtubeRegExp)
      return match && match[2].length === 11 ? match[2] : ''
    },
  },
}
